import { SettingsLayout } from "@/components/layout/SettingsLayout";
import { MetricList } from "@/components/matrix/MetricList";

export function MetricsPage() {
  return (
    <SettingsLayout>
      <div className="space-y-6">
        <div>
          <h2 className="text-2xl font-bold">Scoring Metrics</h2>
          <p className="text-muted-foreground">
            Manage individual scoring metrics and their data sources.
          </p>
        </div>
        <MetricList />
      </div>
    </SettingsLayout>
  );
}
